import { __awaiter } from "tslib";
import { useCallback, useMemo } from "react";
import * as thunkActions from "../actions";
import { useConfigurationDispatch } from "../context/ConfigurationReduxContext";
/**
 * Hook that generates some convenience functions to avoid dispatch
 * - requires {@linkcode ConfigurationController}
 * @category Hook
 * @category CsConfiguration
 * @export
 * @returns {CsCfgObjectApi}
 */
export function useSubstructureApi() {
    const dispatch = useConfigurationDispatch();
    const addSubCfgObject = useCallback((request) => __awaiter(this, void 0, void 0, function* () { return dispatch(thunkActions.addSubCfgObject(request)); }), [dispatch]);
    const copySubCfgObject = useCallback((request) => __awaiter(this, void 0, void 0, function* () { return dispatch(thunkActions.copySubCfgObject(request)); }), [dispatch]);
    const moveSubCfgObject = useCallback((request) => __awaiter(this, void 0, void 0, function* () { return dispatch(thunkActions.moveSubCfgObject(request)); }), [dispatch]);
    const deleteSubCfgObject = useCallback((request) => __awaiter(this, void 0, void 0, function* () { return dispatch(thunkActions.deleteSubCfgObject(request)); }), [dispatch]);
    const enterSubCfgObject = useCallback((request) => __awaiter(this, void 0, void 0, function* () { return dispatch(thunkActions.enterSubCfgObject(request)); }), [dispatch]);
    const exitCurrentCfgObject = useCallback(() => __awaiter(this, void 0, void 0, function* () { return dispatch(thunkActions.exitCurrentCfgObject()); }), [dispatch]);
    const resetSubCfgObject = useCallback((request) => __awaiter(this, void 0, void 0, function* () { return dispatch(thunkActions.resetSubCfgObject(request)); }), [dispatch]);
    return useMemo(() => ({
        addSubCfgObject,
        copySubCfgObject,
        moveSubCfgObject,
        deleteSubCfgObject,
        resetSubCfgObject,
        enterSubCfgObject,
        exitCurrentCfgObject,
    }), [
        addSubCfgObject,
        copySubCfgObject,
        moveSubCfgObject,
        deleteSubCfgObject,
        resetSubCfgObject,
        enterSubCfgObject,
        exitCurrentCfgObject,
    ]);
}
//# sourceMappingURL=useSubstructureApi.js.map